import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';

import { useTranslation } from 'react-i18next';

// ui
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Button } from '@material-ui/core';
import Box from '@material-ui/core/Box';

// style, icons
import { styles } from '../damUseWater/style';

// context
import ModeContext from '../../../context/ModeContext';

const useStyles = makeStyles(styles);

export default function RiskArea(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { datas, currentArea } = props;
  const { handleSelectListClick } = useContext(ModeContext);
  const [code, setCode] = useState(0);

  useEffect(() => {
    if (code > 0) {
      handleSelectListClick(code);
    }
  });

  return (
    <>
      <Box className={classes.boxContent} p={1}>
        <Typography variant="h6">
          {t('ขอบเขตพื้นที่ประกาศภัย')}
        </Typography>

        <ul>
          {orderBy(datas.filter((d) => {
            if (currentArea.code !== '0') {
              return d.province_code === currentArea.code.toString();
            }
            return datas;
          }), ['province_name', 'amphoe_name'], ['asc'])
            .map((d) => (
              <li key={d.id}>
                <Button
                  type="button"
                  onClick={() => setCode(d.province_code)}
                  title={`จ.${d.province_name} อ.${d.amphoe_name} `}
                  style={{
                    left: 0,
                  }}
                >
                  {`จ.${d.province_name} อ.${d.amphoe_name} ต.${d.tambon_name} `}
                </Button>
              </li>
            ))}
        </ul>
      </Box>
    </>
  );
}

RiskArea.propTypes = {
  currentArea: PropTypes.instanceOf(Object).isRequired,
  datas: PropTypes.instanceOf(Object).isRequired,
};
